import React from 'react'
import { useMediaQuery } from 'react-responsive'

import CheckEligibilityBtn from '../components/CheckEligibilityBtn'
import BannerSVG from "../components/bannerSVG"

import img1 from "../assets/img1.png"
import img2 from "../assets/img2.png"
import img3 from "../assets/img3.png"
import img4 from "../assets/img4.png"
import img5 from "../assets/img5.png"
import img6 from "../assets/img6.png"
import img7 from "../assets/img7.png"
import img8 from "../assets/img8.png"
import img9 from "../assets/img9.png"
import img10 from "../assets/img10.png"
import img11 from "../assets/img11.png"
import img12 from "../assets/img12.png"
import work1 from "../assets/works-1.png"
import work2 from "../assets/works-2.png"
import work3 from "../assets/works-3.png"
import work4 from "../assets/works-4.png"



function HomePage() {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 992px)' })
    const is768 = useMediaQuery({ query: '(max-width: 768px)' })

    return (
        <>
            <div className="container">
                <section className="section-one">
                    <div className="row m-0">
                        <div className="col-lg-6">
                            <div className="content">
                                <h1>Your Trusted Financial Concierge</h1>
                                <p className='opd'>Our professionals do all the hard work so you can sleep at night knowing it was done right.</p>
                                <CheckEligibilityBtn styleClass="banner-btn" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="bannerImg">
                                {/* <img src={banner} alt="" className='img-fluid' /> */}
                                <BannerSVG />
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* section-two */}
            {/* <div className="container-fluid p-0">
                {
                    isTabletOrMobile === false ?
                        <section className="section-two">
                            <div className="container justify-content-center">
                                <div className="coloms">
                                    <div className="row">
                                        <div className="col-4 image">
                                            <img src={img1} alt="" className='img-fluid' />
                                        </div>
                                        <div className="col-8 sec2Text">
                                            <h4 className="sec2Heading">Honest & Accurate</h4>
                                        </div>
                                    </div>
                                </div>

                                <div className="coloms">
                                    <div className="row">
                                        <div className="col-4 image">
                                            <img src={img2} alt="" className='img-fluid' />
                                        </div>
                                        <div className="col-8 sec2Text">
                                            <h4 className="sec2Heading">State Licensed CPA’s</h4>
                                        </div>
                                    </div>
                                </div>

                                <div className="coloms">
                                    <div className="row">
                                        <div className="col-4 image">
                                            <img src={img3} alt="" className='img-fluid' />
                                        </div>
                                        <div className="col-8 sec2Text">
                                            <h4 className="sec2Heading">No Upfront Fees</h4>
                                        </div>
                                    </div>
                                </div>

                                <div className="coloms">
                                    <div className="row">
                                        <div className="col-4 image">
                                            <img src={img4} alt="" className='img-fluid' />
                                        </div>
                                        <div className="col-8 sec2Text">
                                            <h4 className="sec2Heading">Multiple Ways To Quality</h4>
                                        </div>
                                    </div>
                                </div>

                                <div className="coloms">
                                    <div className="row">
                                        <div className="col-4 image">
                                            <img src={img5} alt="" className='img-fluid' />
                                        </div>
                                        <div className="col-8 sec2Text">
                                            <h4 className="sec2Heading">Integrity Over Profit</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        :
                        <section className="section-two">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-6 justify-content-center">
                                        <div className="row">
                                            <div className="col-12 d-flex justify-content-center">
                                                <div className="image img1">
                                                    <img src={img1} alt="" className='img-fluid' />
                                                </div>
                                            </div>
                                            <div className="col-12 sec2Text">
                                                <h4 className="sec2Heading">Honest & Accurate</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 justify-content-center">
                                        <div className="row">
                                            <div className="col-12 d-flex justify-content-center">
                                                <div className="image img1">
                                                    <img src={img2} alt="" className='img-fluid' />
                                                </div>
                                            </div>
                                            <div className="col-12 sec2Text">
                                                <h4 className="sec2Heading">State Licensed CPA’s</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 justify-content-center">
                                        <div className="row">
                                            <div className="col-12 d-flex justify-content-center">
                                                <div className="image img1">
                                                    <img src={img3} alt="" className='img-fluid' />
                                                </div>
                                            </div>
                                            <div className="col-12 sec2Text">
                                                <h4 className="sec2Heading">No Upfront Fees</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 justify-content-center">
                                        <div className="row">
                                            <div className="col-12 d-flex justify-content-center">
                                                <div className="image img1">
                                                    <img src={img4} alt="" className='img-fluid' />
                                                </div>
                                            </div>
                                            <div className="col-12 sec2Text">
                                                <h4 className="sec2Heading">Multiple Ways To Quality</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 justify-content-center">
                                        <div className="row">
                                            <div className="col-12 d-flex justify-content-center">
                                                <div className="image img1">
                                                    <img src={img5} alt="" className='img-fluid' />
                                                </div>
                                            </div>
                                            <div className="col-12 sec2Text">
                                                <h4 className="sec2Heading">Integrity Over Profit</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                }
            </div> */}

            
       <section class="banner-advantages" data-v-9858b05e>
          <div class="container" data-v-9858b05e>
            <div class="banner-advantages__item" data-v-9858b05e>
              <div class="banner-advantages__img" data-v-9858b05e> <img src={img1} alt="" className='img-fluid' /></div>
              <h3 data-v-9858b05e>Honest &amp; Accurate</h3>
            </div>
            <div class="banner-advantages__item" data-v-9858b05e>
              <div class="banner-advantages__img" data-v-9858b05e> <img src={img2} alt="" className='img-fluid' /></div>
              <h3 data-v-9858b05e>State Licensed CPA’s</h3>
            </div>
            <div class="banner-advantages__item" data-v-9858b05e>
              <div class="banner-advantages__img" data-v-9858b05e> <img src={img3} alt="" className='img-fluid' /></div>
              <h3 data-v-9858b05e>No Upfront Fees</h3>
            </div>
            <div class="banner-advantages__item" data-v-9858b05e>
              <div class="banner-advantages__img" data-v-9858b05e> <img src={img4} alt="" className='img-fluid' /></div>
              <h3 data-v-9858b05e>Multiple Ways To Quality`</h3>
            </div>
            <div class="banner-advantages__item" data-v-9858b05e>
              <div class="banner-advantages__img" data-v-9858b05e> <img src={img5} alt="" className='img-fluid' /></div>
              <h3 data-v-9858b05e>Integrity Over Profit</h3>
            </div>
          </div>
        </section>


            {/* section-three */}
            <div className="bg-light">
                <div className="container">
                    <section className='section-three'>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className="leftText">
                                    <h2>The Done-For-You ERC Service.</h2>
                                    <h4 style={{ fontFamily: 'Montserrat-Medium' }}>We Make The Complicated Simple.</h4>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-lg-75">
                                <div className="rightText">
                                    <h3>We do this by listening and understanding your businesses, identifying your needs, making a plan and holding your hand as we help you utilize government programs, get funding, and optimize your taxes.</h3>
                                    <ul>
                                        <li>Each account is overseen by a licensed CPA</li>
                                        <li>We make sure all numbers are accurate and fit within ERC regulations so you can “sleep well at night”</li>
                                        <li>Our ERC experts will take care of the paperwork so you can focus on running your business.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>


            {/* section-four */}
            <div className="bg-light">
                <div className="container">
                    <section className='section-four'>
                        <div className="row">
                            <div className="col-lg-6 col-md-12 left-cont">
                                <div className="row">

                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 mb-4">
                                    <div className="content">
                                        <div className="icon">
                                            <img src={img6} alt="" className='img-fluid' />
                                        </div>
                                        <h3>Construction</h3>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 mb-4">
                                    <div className="content">
                                        <div className="icon">
                                            <img src={img7} alt="" className='img-fluid' />
                                        </div>
                                        <h3>Restaurants / QSR</h3>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 mb-4">
                                    <div className="content">
                                        <div className="icon">
                                            <img src={img8} alt="" className='img-fluid' />
                                        </div>
                                        <h3>Warehouse / 3PL</h3>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 mb-4">
                                    <div className="content">
                                        <div className="icon">
                                            <img src={img9} alt="" className='img-fluid' />
                                        </div>
                                        <h3>Business Services</h3>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 mb-4">
                                    <div className="content">
                                        <div className="icon">
                                            <img src={img10} alt="" className='img-fluid' />
                                        </div>
                                        <h3>Retail</h3>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 mb-4">
                                    <div className="content">
                                        <div className="icon">
                                            <img src={img11} alt="" className='img-fluid' />
                                        </div>
                                        <h3>Mechanical Supplies</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mb-sm-5 right-cont-area">
                                <div className="right-cont">
                                    <h2>Industries We’ve Helped</h2>
                                    <p>We’ve helped clients of all sizes and across multiple different industries.</p>
                                    <CheckEligibilityBtn styleClass="right-cont-btn" />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>


            {/* section-five */}
            <div className="">
                <div className="container">
                    <section className='section-five'>
                        {
                            is768 ?
                                <div className="row content">
                                    <div className="col-12">
                                        <h2>Some Recent Fillings</h2>
                                    </div>
                                    <div className="col-12 content-items">
                                        <div className="content-item-img">
                                            <img src={img12} alt="" className='img-fluid' />
                                        </div>
                                        Mechanical Supplies $1,197,460.83
                                    </div>
                                    <div className="col-12 content-items">
                                        <div className="content-item-img">
                                            <img src={img12} alt="" className='img-fluid' />
                                        </div>
                                        Restaurant $907,061.63
                                    </div>
                                    <div className="col-12 content-items">
                                        <div className="content-item-img">
                                            <img src={img12} alt="" className='img-fluid' />
                                        </div>
                                        Construction $403,327.64
                                    </div>
                                </div>
                                :
                                <div className="row">
                                    <div className="content">
                                        <h2>Some Recent Fillings</h2>

                                        <div className="content-items">
                                            <div className="content-item-img">
                                                <img src={img12} alt="" className='img-fluid' />
                                            </div>
                                            Mechanical Supplies $1,197,460.83
                                        </div>
                                        <div className="content-items">
                                            <div className="content-item-img">
                                                <img src={img12} alt="" className='img-fluid' />
                                            </div>
                                            Restaurant $907,061.63
                                        </div>
                                        <div className="content-items">
                                            <div className="content-item-img">
                                                <img src={img12} alt="" className='img-fluid' />
                                            </div>
                                            Construction $403,327.64
                                        </div>
                                    </div>
                                </div>
                        }
                    </section>
                </div>
            </div>



            {/* section-six */}
            <div className="">
                <div className="container">
                    <section className='section-six'>
                        <div className="row">
                            <div className="content">
                                <h2>How It Works</h2>
                                <div className="row work-card">
                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="work-item">
                                            <img src={work1} alt="" className='img-fluid' />
                                            Take the Qualification Quiz
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="work-item">
                                            <img src={work2} alt="" className='img-fluid' />
                                            Fill Out Application (Online or Phone)
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="work-item">
                                            <img src={work3} alt="" className='img-fluid' />
                                            Work With Our Team to Get Docs and Info
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="work-item">
                                            <img src={work4} alt="" className='img-fluid' />
                                            Processing, Submission and Payment from IRS
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>


            {/* section-faq */}
            <div className="">
                <div className="container">
                    <section className='section-faq'>
                        <div className="row">
                            <div className="content">
                                <h2>FREQUENTLY ASKED QUESTIONS</h2>

                                <div className="faq-card">
                                    <div className="row mt-3 m-0 justify-content-center">
                                        <div className="col-lg-6 col-md-6 col-sm-12 my-2 faq-list">
                                            <div className="faq-item">
                                                <div className="fa-questions">
                                                    <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample1" aria-expanded="false" aria-controls="collapseExample">
                                                        Is the ERC program a loan?
                                                    </p>
                                                </div>
                                                <div className="fa-answers">
                                                    <div className="collapse" id="collapseExample1">
                                                        Nope! This is not a loan. There is nothing to repay with a tax credit.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-12 my-2 faq-list">
                                            <div className="faq-item">
                                                <div className="fa-questions">
                                                    <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
                                                        Can we qualify if our revenue went up in 2020 or 2021?
                                                    </p>
                                                </div>
                                                <div className="fa-answers">
                                                    <div className="collapse" id="collapseExample2">
                                                    Yes! It’s called the “Employee Retention” credit, not the “Revenue Reduction” credit. It’s intended to help out the businesses that kept people employed during the hard times of pandemic, so you can qualify even if your revenue went up. You’ll need to qualify using one of the other qualification checks though – shutdowns / mandates or supply chain disruption.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 my-2 faq-list">
                                            <div className="faq-item">
                                                <div className="fa-questions">
                                                    <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="false" aria-controls="collapseExample">
                                                        Can we qualify if we already received a PPP loan?
                                                    </p>
                                                </div>
                                                <div className="fa-answers">
                                                    <div className="collapse" id="collapseExample3">
                                                    Yes! There are multiple quarters you can qualify for, even if you got a PPP loan. Unfortunately you can’t use the same covered time period that you used for PPP, which might reduce your ERC amount, but you can most definitely qualify for ERC.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 my-2 faq-list">
                                            <div className="faq-item">
                                                <div className="fa-questions">
                                                    <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="false" aria-controls="collapseExample">
                                                        Wasn’t the ERC program from several years ago?
                                                    </p>
                                                </div>
                                                <div className="fa-answers">
                                                    <div className="collapse" id="collapseExample4">
                                                    Not really, for most businesses this will be open into 2024 (unless they change the rules again). It’s open as long as you can file amended 941-X returns, which is the later of 3 years from the date you filed your original return, or 2 years from the date you paid the payroll tax.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6">
                                            <CheckEligibilityBtn styleClass="faq-btn" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>


        </>
    )
}

export default HomePage
